<template>
  <v-menu max-width="300" nudge-bottom="20">
    <template #activator="{ attr, on }">
      <v-icon v-bind="attr" v-on="on" small class="ml-2" color="warning">
        mdi-information-variant-circle-outline
      </v-icon>
    </template>
    <v-card class="pa-3" style="min-width: 220px">
      <div class="font-weight-bold mb-2">Card Layout</div>

      <div class="text-caption mb-1">
        <strong>Row:</strong>
        Cards are arranged horizontally in a single line, allowing you to scroll
        sideways if there are more cards than fit on the screen.
        <br />
        <strong>Grid:</strong>
        Cards are displayed in a grid with multiple rows and columns, making it
        easier to view more cards at once.
      </div>
      <div class="text-caption grey--text">
        <span>
          Select a card layout to control how your quick info cards are
          organized and displayed on the dashboard.
        </span>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "CardLayoutInstruction",
};
</script>
